import React from 'react'
import { navigate } from "gatsby"

import OtherArticleSection from '../OtherArticleSection'
import moment from 'moment'

import { Grid } from '@material-ui/core'
import newsStyle from "../newsStyle.jsx"
import withStyles from "@material-ui/core/styles/withStyles"
import copy from '../../../constants/copy.json'

const OtherArticleSide = ({classes, rassegnaList, maxArticle}) => {

  const rassegnaListFilter = rassegnaList && rassegnaList.sort((a, b) => moment(b.acfRassegna.date, 'DD/MM/YYYY').valueOf() - moment(a.acfRassegna.date, 'DD/MM/YYYY').valueOf())
    .slice(0, maxArticle);

  const rassegnaArticleList = rassegnaListFilter.map((item, idx) => {
      return (
        <OtherArticleSection key={idx} type='rassegna' article={item.acfRassegna} articleNumber={rassegnaListFilter.length} idx={idx}/>
      );
  });
  
  return (
    <>
    {rassegnaArticleList && rassegnaArticleList.length > 0 &&
      <Grid container className={classes.articleList} style={{cursor: 'pointer'}} alignItems='center' direction='column' onClick={()=> navigate(`/rassegna-stampa`)}>
        <Grid item className={classes.titleOtherArticle}>
          SFOGLIA LA
        </Grid>
        <Grid item className={classes.titleR}>
        {copy.news.rassegnaStampa.title}
        </Grid>
        <Grid container style={{marginTop: '30px'}}>
          {rassegnaArticleList}
        </Grid>
      </Grid>}
    </>
  )
};

export default withStyles(newsStyle)(OtherArticleSide)
